import { PackageX, ShoppingCart, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtQty } from "@/lib/constants";

// Dashboard tile: materials that will run short for orders due within the week.
export default function ShortageTile({ data, onPurchase }) {
  const rows = data?.materials || [];
  const short = rows.length > 0;
  return (
    <div className={`bg-white rounded-xl border shadow-sm ${short ? "border-red-200" : "border-slate-200"}`} data-testid="shortage-tile">
      <div className="px-5 py-4 border-b border-slate-100 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className={`h-9 w-9 rounded-lg flex items-center justify-center ${short ? "bg-red-50 text-red-600" : "bg-emerald-50 text-emerald-600"}`}>
            {short ? <PackageX className="h-4.5 w-4.5" /> : <CheckCircle2 className="h-4.5 w-4.5" />}
          </span>
          <div>
            <h3 className="font-display text-base font-semibold text-slate-900">Material Shortages · This Week</h3>
            <p className="text-xs text-slate-400" data-testid="shortage-tile-subtitle">
              {short ? `${rows.length} material${rows.length > 1 ? "s" : ""} short` : "All materials covered"} · {data?.orders_checked ?? 0} order{data?.orders_checked === 1 ? "" : "s"} due in {data?.horizon_days ?? 7} days
            </p>
          </div>
        </div>
        {short && onPurchase && (
          <Button size="sm" className="h-8 text-xs bg-red-600 hover:bg-red-700" onClick={onPurchase} data-testid="shortage-tile-purchase">
            <ShoppingCart className="h-3.5 w-3.5 mr-1" /> Purchase List
          </Button>
        )}
      </div>
      {short ? (
        <ul className="divide-y divide-slate-100 max-h-72 overflow-y-auto" data-testid="shortage-tile-list">
          {rows.map((m) => (
            <li key={m.item_id} className="px-5 py-2.5 flex items-center gap-4 text-sm" data-testid={`shortage-row-${m.sku}`}>
              <div className="min-w-0 flex-1">
                <p className="font-medium text-slate-800 truncate">{m.name}</p>
                <p className="text-[11px] text-slate-400 font-mono-data truncate">{m.sku} · {m.orders.join(", ")}</p>
              </div>
              <div className="text-right shrink-0 text-[11px] text-slate-500 font-mono-data">
                need {fmtQty(m.required, m.unit)} · have {fmtQty(m.in_stock, m.unit)}
              </div>
              <span className="shrink-0 rounded-md bg-red-50 text-red-700 px-2 py-1 text-xs font-semibold font-mono-data" data-testid={`shortage-missing-${m.sku}`}>
                −{fmtQty(m.missing, m.unit)} {m.unit}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="px-5 py-6 text-center text-sm text-slate-400">Stock covers every order due this week.</p>
      )}
    </div>
  );
}
